module.exports = __webpack_public_path__ + "static/media/amex.e6574be4.webp";